<button matRipple class="back-btn">
  <svg *ngIf="!cross" class="arrow-icon" width="23" height="20" viewBox="0 0 23 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.3694 4L5.57148 9L10.3694 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <line x1="1" y1="-1" x2="11.6665" y2="-1" transform="matrix(1 0 0 -1 5.76221 8.30835)" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
  </svg>

  <svg *ngIf="cross" class="cross-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d)">
      <path d="M18.4163 4.58337L5.58301 17.4167" stroke="white" stroke-width="2" stroke-linecap="round"/>
      <path d="M5.58268 4.58337L18.416 17.4167" stroke="white" stroke-width="2" stroke-linecap="round"/>
    </g>
    <defs>
      <filter id="filter0_d" x="-3" y="-3" width="30" height="30" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="1"/>
        <feGaussianBlur stdDeviation="2"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
    </defs>
  </svg>

</button>
